import { render, staticRenderFns } from "./FormAssocianteTipoRegistro.vue?vue&type=template&id=91e7e06a"
import script from "./FormAssocianteTipoRegistro.vue?vue&type=script&lang=js"
export * from "./FormAssocianteTipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports